import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import ChatbotEmbed from '~/components/chatbotEmbed'
import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import WarningUnsavedChanges from '~/components/warningUnsavedChanges'
import useResetAgentForGuestUsers from '~/features/agents/hooks/useResetAgentForGuestUsers'
import useResetChatbotSettings from '~/features/agents/hooks/useResetChatbotSettings'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'

function ConfigLayout() {
  useResetChatbotSettings()
  useResetAgentForGuestUsers()
  const { partner, isLoading: isLoadingPartner } = usePartnerCentralized()
  const showEmbeddedChatbot = !isLoadingPartner && partner.showEmbeddedChat

  return (
    <Suspense fallback={<LoadingWithBackdrop show />}>
      {showEmbeddedChatbot && <ChatbotEmbed />}
      <Outlet />
      <WarningUnsavedChanges />
    </Suspense>
  )
}

export default ConfigLayout
